import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';

export const selectFloorn = createSelector(selectJsonQuery, jsonQuery => getRangeValue('floorn')(jsonQuery));
